import axios, { type AxiosResponse } from "axios";
import type { Message } from "../components/Message/types";
import { baseUrl } from "./constants";

// Output types
export interface GetChatMessagesResponse {
  messages: Message[];
}

// API function
export async function getChatMessages(
  session_id: string,
): Promise<AxiosResponse<GetChatMessagesResponse>> {
  return axios.get(`${baseUrl}/api/v1/quotation-request-chat/sessions/${session_id}/messages`);
}
